import React from 'react';

const FBContext = React.createContext(null);

export default FBContext;